import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { SERVICE_ICONS, ICON_KEYS } from "../data/icons";

/**
 * Kompakte Icon-Auswahl als Grid-Popover.
 * Props: value (icon-key), onChange(newKey)
 */
export default function IconPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const current = SERVICE_ICONS[value] || SERVICE_ICONS.stethoscope;
  const Current = current.component;

  return (
    <div className="icon-picker" data-testid="icon-picker">
      <button
        type="button"
        className="icon-picker-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid="icon-picker-trigger"
      >
        <Current size={20} strokeWidth={1.5} />
        <span>{current.label}</span>
        <ChevronDown size={14} />
      </button>
      {open && (
        <div className="icon-picker-grid" role="menu" data-testid="icon-picker-grid">
          {ICON_KEYS.map((k) => {
            const Icon = SERVICE_ICONS[k].component;
            return (
              <button
                key={k}
                type="button"
                className={`icon-picker-option${k === value ? " is-active" : ""}`}
                onClick={() => { onChange(k); setOpen(false); }}
                title={SERVICE_ICONS[k].label}
                data-testid={`icon-picker-option-${k}`}
              >
                <Icon size={22} strokeWidth={1.5} />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
